import { Skeleton } from "@mui/material";

/** Skeleton component to display in the projects map */
export function ProjectsMapSkeleton(): JSX.Element {
  return (
    <Skeleton
      variant="rectangular"
      sx={{ width: "100%", height: "100%" }}
    />
  );
}
